<template>
  <div class="letter_wrap notice-page">
    <div class="red_top_bg page-top">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{ $t('notice.message') }}
      </div>
    </div>

    <div class="msg_box">
      <van-empty
        v-if="empty"
        :description="$t('orders.noOrders')"
      />
      <article
        v-for="item in noticeList"
        v-else
        :key="item.id"
        class="notice-card"
        @click="$router.push('/notice/' + item.id)"
      >
        <div class="notice-head">
          <div class="notice-title van-ellipsis">
            <span
              v-if="item.status == 0"
              class="unread-dot"
            >
              <van-icon
                name="warning-o"
                size="13"
              />
            </span>
            {{ item[title] }}
          </div>
          <time class="notice-time">
            {{ item.add_time }}
          </time>
        </div>
        <div
          class="notice-content van-multi-ellipsis--l2"
          v-html="item[content]"
        />
      </article>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Empty, Icon } from "vant";
import Fetch from "../../utils/fetch";

Vue.use(Empty).use(Icon);

export default {
	name: "Login",
	data() {
		return {
			title: "title" ,
			content: "content" ,
			empty: false,
			data: {
				list: [],
			},
		};
	},
	computed: {
		noticeList() {
			return this.data && this.data.list ? this.data.list : [];
		},
	},
	created() {
		this.$parent.footer("user", false);
	},
	mounted() {
		this.start();
	},
	methods: {
		start() {
			Fetch("/user/notice").then(r => {
				var list = r.data && r.data.list ? r.data.list : [];

				this.data = r.data;
				this.empty = list.length === 0;
			});
		},
	},
};
</script>

<style lang="less" scoped>
.notice-page {
	min-height: 100vh;
	background: #111;
	color: #f6f6f6;
	padding-bottom: 80px;
	box-sizing: border-box;
}

.page-top {
	height: 50px;
	background: #101010;
	color: #f6f6f6;
	border-bottom: 1px solid #242424;
	box-sizing: border-box;

	.back_left {
		opacity: 0.88;
	}

	.big_tit {
		color: #fff;
	}
}

.msg_box {
	padding: 16px 20px 0;
}

.notice-card {
	margin-bottom: 14px;
	padding: 16px 18px;
	border-radius: 12px;
	border: 1px solid #303030;
	background: #222;
	box-sizing: border-box;
}

.notice-head {
	display: flex;
	align-items: center;
	justify-content: space-between;
	min-width: 0;
}

.notice-title {
	min-width: 0;
	flex: 1;
	color: #fff;
	font-size: 14px;
	font-weight: 800;
	line-height: 22px;
}

.unread-dot {
	width: 18px;
	height: 18px;
	margin-right: 6px;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
	background: rgba(255, 74, 74, 0.14);
	color: #ff4a4a;
	vertical-align: -3px;
}

.notice-time {
	flex: 0 0 auto;
	max-width: 42%;
	margin-left: 12px;
	color: rgba(255, 255, 255, 0.5);
	font-size: 12px;
	line-height: 18px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.notice-content {
	margin-top: 10px;
	color: rgba(255, 255, 255, 0.64);
	font-size: 14px;
	line-height: 20px;
}

/deep/ .notice-content * {
	max-width: 100%;
}

/deep/ .van-empty {
	padding-top: 72px;
}

/deep/ .van-empty__description {
	color: rgba(255, 255, 255, 0.56);
}

@media screen and (max-width: 374px) {
	.msg_box {
		padding-right: 12px;
		padding-left: 12px;
	}

	.notice-card {
		padding-right: 14px;
		padding-left: 14px;
	}
}
</style>
